import { useEditor } from '@smartfire/js-block-engine';
import clsx from 'clsx';
import { useState, useEffect } from 'react';
import { ReactComponent as Logo } from '../../assets/MyHand-logo.svg';
import BurgerMenu from './BurgerMenu';
import BurgerIcon from './BurgerIcon.jsx';
import style from './style.module.scss';

const HeaderMobile = ({
    menu,
    secondMenu,
    customSettings,
    accountBlock = null,
    isRegistrationPage = false,
    hideMobileLogo = false,
    isLandingPage = false,
    isUserConnected = false,
}) => {
    const { isEditing } = useEditor();
    const [openBurger, setOpenBurger] = useState(false);
    const WrapperLink = isEditing ? 'div' : 'a';

    useEffect(() => {
        if (openBurger) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }, [openBurger]);

    return isRegistrationPage ? (
        <div className={clsx(style.header, style.registrationPage)}>
            <WrapperLink href="/" className={style.logoContainer}>
                <Logo />
            </WrapperLink>
        </div>
    ) : isLandingPage ? (
        <div className={clsx(style.header, style.landingPage)}>
            <WrapperLink href="/" className={style.logoContainer}>
                <Logo />
            </WrapperLink>
        </div>
    ) : (
        <>
            <div className={style.header}>
                <div className={style.firstRow}>
                    <BurgerIcon onClick={() => setOpenBurger(true)} />

                    {!hideMobileLogo && (
                        <WrapperLink href="/" className={style.logoContainer}>
                            <Logo />
                        </WrapperLink>
                    )}

                    {accountBlock}
                </div>
            </div>

            {!isEditing && (
                <BurgerMenu
                    open={openBurger}
                    menu={menu}
                    secondMenu={secondMenu}
                    customSettings={customSettings}
                    handleClose={() => setOpenBurger(false)}
                    account={accountBlock}
                    isUserConnected={isUserConnected}
                />
            )}
        </>
    );
};

export default HeaderMobile;
